var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white layout-padding horizontal" },
    [
      _c("div", { staticClass: "q-py-md" }, [
        _c(
          "div",
          { staticClass: "block relative-position" },
          [
            _c(
              "q-btn",
              {
                staticClass: "absolute absolute-top-right",
                attrs: {
                  icon: "more_vert",
                  color: "faded",
                  flat: "",
                  round: "",
                  dense: ""
                }
              },
              [
                _c(
                  "q-popover",
                  [
                    _c(
                      "q-list",
                      { staticClass: "no-border", attrs: { link: "" } },
                      [
                        _c(
                          "q-item",
                          {
                            directives: [
                              {
                                name: "close-overlay",
                                rawName: "v-close-overlay"
                              },
                              { name: "is-user", rawName: "v-is-user" }
                            ],
                            nativeOn: {
                              click: function($event) {
                                return _vm.handleEdit($event)
                              }
                            }
                          },
                          [
                            _c("q-item-side", { attrs: { icon: "edit" } }),
                            _c("q-item-main", {
                              attrs: { label: _vm.$t("edit") }
                            })
                          ],
                          1
                        ),
                        _c("q-item-separator"),
                        _vm.project.active
                          ? _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-overlay",
                                    rawName: "v-close-overlay"
                                  },
                                  { name: "is-user", rawName: "v-is-user" }
                                ],
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.handleArchive($event)
                                  }
                                }
                              },
                              [
                                _c("q-item-side", {
                                  attrs: { icon: "archive" }
                                }),
                                _c("q-item-main", {
                                  attrs: { label: _vm.$t("archive") }
                                })
                              ],
                              1
                            )
                          : _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-overlay",
                                    rawName: "v-close-overlay"
                                  },
                                  { name: "is-user", rawName: "v-is-user" }
                                ],
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.handleUnarchive($event)
                                  }
                                }
                              },
                              [
                                _c("q-item-side", {
                                  attrs: { icon: "unarchive" }
                                }),
                                _c("q-item-main", {
                                  attrs: { label: _vm.$t("unarchive") }
                                })
                              ],
                              1
                            )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "row gutter-x-md" }, [
          _c(
            "div",
            { staticClass: "col-auto gt-md" },
            [
              _c("placeholder-avatar", {
                staticClass: "q-display-1",
                attrs: {
                  width: "96px",
                  height: "96px",
                  initials: _vm.projectInitials
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "row full-height" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _vm.hasCustomer
                      ? _c("customer-indicator", {
                          attrs: {
                            clickable: "",
                            "hide-icon": "",
                            customer: _vm.customer
                          },
                          on: { click: _vm.handleCustomerIndicatorClick }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("div", { staticClass: "row items-center no-wrap q-ml-sm" }, [
                  _c("div", [
                    _c("div", {
                      staticClass: "project-details__color-indicator circle",
                      style: { "background-color": _vm.projectColor }
                    })
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "q-title text-dark on-right block ellipsis"
                    },
                    [_vm._v(_vm._s(_vm.project.name))]
                  ),
                  !_vm.project.active
                    ? _c(
                        "div",
                        { staticClass: "on-right" },
                        [
                          _c(
                            "q-chip",
                            {
                              attrs: {
                                dense: "",
                                color: "warning",
                                "text-color": "white"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("archived")))]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm.estimatedHours
                  ? _c(
                      "div",
                      {
                        staticClass: "row items-center no-wrap q-mt-sm q-ml-sm"
                      },
                      [
                        _c(
                          "progress",
                          {
                            staticClass: "project-details__progress",
                            style: _vm.progressBarStyle,
                            attrs: { max: _vm.estimatedHours },
                            domProps: { value: _vm.billableHours }
                          },
                          [
                            _c("q-tooltip", {
                              attrs: { offset: [0, 4] },
                              domProps: {
                                innerHTML: _vm._s(_vm.progressTooltipText)
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 row items-end justify-between gutter-y-xs q-ml-sm q-mt-md q-mt-md-none"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-auto row gutter-x-md gutter-y-xs" },
                    [
                      _vm.startDate
                        ? _c("div", { staticClass: "col-12 col-sm-auto" }, [
                            _c(
                              "span",
                              { staticClass: "text-dark text-bold no-margin" },
                              [_vm._v(_vm._s(_vm.startDate))]
                            ),
                            _c(
                              "span",
                              { staticClass: "text-faded text-weight-light" },
                              [_vm._v(" " + _vm._s(_vm.$t("start_date")))]
                            )
                          ])
                        : _vm._e(),
                      _vm.endDate
                        ? _c("div", { staticClass: "col-12 col-sm-auto" }, [
                            _c(
                              "span",
                              { staticClass: "text-dark text-bold no-margin" },
                              [_vm._v(_vm._s(_vm.endDate))]
                            ),
                            _c(
                              "span",
                              { staticClass: "text-faded text-weight-light" },
                              [_vm._v(" " + _vm._s(_vm.$t("end_date")))]
                            )
                          ])
                        : _vm._e(),
                      _vm.showBudget
                        ? _c("div", { staticClass: "col-12 col-sm-auto" }, [
                            _c(
                              "span",
                              { staticClass: "text-dark text-bold no-margin" },
                              [_vm._v(_vm._s(_vm.budget))]
                            ),
                            _c(
                              "span",
                              { staticClass: "text-faded text-weight-light" },
                              [_vm._v(" " + _vm._s(_vm.$t("project_budget")))]
                            )
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "col-12 col-sm-auto" }, [
                        _c(
                          "span",
                          { staticClass: "text-dark text-bold no-margin" },
                          [_vm._v(_vm._s(_vm.hourlyRate))]
                        ),
                        _c(
                          "span",
                          { staticClass: "text-faded text-weight-light" },
                          [_vm._v(" " + _vm._s(_vm.$t("hourly_rate")))]
                        )
                      ]),
                      _c("div", { staticClass: "col-12 col-sm-auto" }, [
                        _c(
                          "span",
                          { staticClass: "text-dark text-bold no-margin" },
                          [_vm._v(_vm._s(_vm.billableHours))]
                        ),
                        _c(
                          "span",
                          { staticClass: "text-faded text-weight-light" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("project_billable_hours"))
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col-12 col-sm-auto" }, [
                        _c(
                          "span",
                          { staticClass: "text-dark text-bold no-margin" },
                          [_vm._v(_vm._s(_vm.openHours))]
                        ),
                        _c(
                          "span",
                          { staticClass: "text-faded text-weight-light" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$tc("open_hour", _vm.openHours))
                            )
                          ]
                        )
                      ]),
                      _vm.estimatedHours
                        ? _c("div", { staticClass: "col-12 col-sm-auto" })
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-auto q-mt-sm" },
                    [
                      _c("q-btn", {
                        attrs: {
                          rounded: "",
                          outline: "",
                          color: "primary",
                          label: _vm.$t("settle_hours")
                        },
                        on: { click: _vm.handleSettleProject }
                      })
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _c("project-modal", {
        ref: "editProjectModal",
        attrs: { project: _vm.project },
        on: { save: _vm.handleSaveProject }
      }),
      _c("settle-project-modal", {
        ref: "settleProjectModal",
        attrs: { project: _vm.project },
        on: { "settle-project": _vm.handleConfirmSettleProject }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }